import axios from "axios";
import { EvaluationStart, EvaluationWithDeadlineAndHomework, EvaluationWithRelatedData } from "@/models/evaluation";
import { applyErrorHandlers } from '@/decorators/applyErrorHandler';

const API_EVALUATION_URL = process.env.VUE_APP_API_URL+"/evaluations";
const API_SUBEVALUATION_URL = process.env.VUE_APP_API_URL+"/subevaluations";
const API_FILE_URL = process.env.VUE_APP_API_URL+"/files";

export default class EvaluationController {
    static async fetchEvaluationsWithDeadlineAndHomework(studentId = null) {
        // If no specific studentId is providet, fetch data for current student
        if (studentId == null) {
            return;
        }
        const response = await axios.get(`${API_EVALUATION_URL}/get_evaluations_by_student_id_with_deadline_and_homework/${studentId}`);
        console.log("Evaluations fetched successfully:", response.data);
        return response.data.map(evaluation => new EvaluationWithDeadlineAndHomework(evaluation));
    }

    static async fetchEvaluationByIdWithRelatedData(evaluationId) {
        const response = await axios.get(`${API_EVALUATION_URL}/get_evaluation_by_id_with_related_data/${evaluationId}`);
        console.log("Evaluation details fetched successfully:", response.data);
        return new EvaluationWithRelatedData(response.data);
    }

    static async fetchEvaluationStats(deadlineId) {
        const response = await axios.get(`${API_EVALUATION_URL}/get_evaluation_stats/${deadlineId}`);
        console.log("Evaluation stats fetched successfully:", response.data);
        return response.data;
    }

    static async fetchSubtaskSummary(deadlineId) {
        const response = await axios.get(`${API_SUBEVALUATION_URL}/get_subtask_summary_by_deadline/${deadlineId}`);
        console.log("Subtask summary fetched successfully:", response.data);
        return response.data;
    }

    static async startEvaluation(startEvaluationData) {
        // Validate data using Evaluation model
        EvaluationStart.validate(startEvaluationData);
        const response = await axios.post(`${API_EVALUATION_URL}/start_evaluation`, startEvaluationData);
        console.log("Evaluation started successfully:", response.data);
        return response.data;
    }

    static async deleteEvaluationRun(deadlineId, deleteDeadline) {
        // Check if deleteDeadline is a boolean
        if (typeof deleteDeadline !== 'boolean') {
            throw new Error("deleteDeadline must be a boolean value.");
        }
        const response = await axios.delete(`${API_EVALUATION_URL}/delete_evaluation_run/${deadlineId}/${deleteDeadline}`);
        console.log("Evaluation run deleted successfully:", response.data);
        return response.data;
    }

    // Download a file
    static async downloadFile(filePath) {
        const response = await axios.get(`${API_FILE_URL}/download_file`, {
            params: { relative_file_path: filePath },
            responseType: 'blob'
        });
        return response;
    }

    static async downloadFilesForPlagiateDetection(studentId, deadlineId) {
        const response = await axios.get(`${API_FILE_URL}/download_files_for_plagiate_detection/${deadlineId}/${studentId}`, {
          responseType: 'blob'
        });
        return response;
    }
}

applyErrorHandlers(EvaluationController);